import React, { useContext } from 'react';
import { ChartWrapper, Main } from 'Benchmarks/Benchmarks.styles';
import ProcurementFilters from '../ProcurementFilters/ProcurementFilters';
import { procurementMetricsContext } from '../Context/ProcurementMetricsContextProvider';
import TableRowsWithSelectedOptions from '../Components/TableRowsWithSelectedOptions/TableRowsWithSelectedOptions';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import {
	AnalysisWrapper2,
	GreenBox,
	LoaderWrapper,
	ReferenceContainer,
} from '../../components/BenchmarkContainer/BenchmarkContainer.styles';

const ProcurementMetricsCategorical = () => {
	const { tab2Data, loadingTab2 } = useContext(procurementMetricsContext);
	return (
		<Main>
			<ChartWrapper loadingTab2={loadingTab2}>
				<ProcurementFilters />
				<AnalysisWrapper2
					index="0"
					loadingTab2={loadingTab2}
					tab2Data={tab2Data}
				>
					<ReferenceContainer>
						Reference Performace Range ( <GreenBox />
						- Green boxes indicate your selection )
					</ReferenceContainer>
					{loadingTab2 ? (
						<LoaderWrapper>
							<ApLoaderDefault />
						</LoaderWrapper>
					) : (
						<>
							{tab2Data.length > 0 &&
								tab2Data.map((item, index) => {
									return (
										<TableRowsWithSelectedOptions
											key={index}
											name={item.name}
											metricsData={item.data}
											index={index}
										/>
									);
								})}
						</>
					)}
				</AnalysisWrapper2>
			</ChartWrapper>
		</Main>
	);
};

export default ProcurementMetricsCategorical;
